const defaultObj = {};

export const getPlatformConfig = (state) => state.PlatformConfig.platformConfig || defaultObj;

export const getPlatformConfigLoading = (state) => state.PlatformConfig.loadingplatformConfig || false;

export const getTimeOffAllowedCountries = (state, anniversaryBasedTimeOff = false) => {
  const platformConfig = state.PlatformConfig.platformConfig?.payload || defaultObj;

  if (anniversaryBasedTimeOff) {
    return platformConfig?.TIMEOFF_ALLOWED_COUNTRIES_V2 || [];
  }
  return platformConfig?.TIMEOFF_ALLOWED_COUNTRIES || [];
};
